import { ApolloLink } from '@apollo/client';

export const createForcePostRequestLink = () =>
  new ApolloLink((operation, forward) => {
    const context = operation.getContext();
    if (context.forcePostRequest) {
      operation.setContext({
        fetchOptions: {
          ...context.fetchOptions,
          method: 'POST',
        },
      });
    }
    return forward(operation);
  });
